import React, { useState } from 'react';
import Navbar from '../components/navbar';
import "../styles/home.css"
import "antd/dist/antd.css"
import ContactForm from '../components/contactForm';
import Card from "../components/card"

import clockimg from "../assets/images/service-time-icon.png"
import achievementimg from "../assets/images/service-trophy-icon.png"
import tutorimg from "../assets/images/besttutor-icon.png"
// import locationimg from "../assets/images/service-location-icon.png"
import learningicon from "../assets/images/learning-icon.png"
import trialclassicon from "../assets/images/trialclass-icon.png"
import certificateicon from "../assets/images/certificate-icon.png"

import waicon from "../assets/images/waicon.png"

// cards images
import learnQuranCardImg from '../assets/images/quran-learn.jpg'
import CourseCards from '../components/courseCard';
import Courses from './courses';
import CardModal from "../components/cardModal"

export default function Home(props) {

    const servicesCards = [
        {
            title: "FLEXIBLE TIMING",
            description: " We provide 24/7 service for learning. Which help students to schedule the classes according to their availability. You can decide timings for your session according to your own convenience.",
            img: clockimg
        },
        {
            title: "GET FREE TRIAL CLASS",
            description: "No OBLIGATIONS! We offer free trial class on any course of your choice to evaluate our tutors & courses. After the free class, you are free to continue or discontinue learning with us.",
            img: trialclassicon
        },
        {
            title: "BEST TUTORS",
            description: "Learn online with highly qualified, well trained, and extremely capable male & female tutors.",
            img: tutorimg
        },
        {
            title: "COMPLETIONS CERTIFICATE",
            description: "We have provided proper certificate to students after completing course stating that you have passed the course successfully.",
            img: certificateicon
        },
        {
            title: "INDIVIDUAL LEARNING SESSION",
            description: "We offer one to one learning session so that students get proper attention from the teacher that is not possible in large number of students.",
            img: learningicon
        },


    ]

    const [cardModalState, setcardModalState] = useState(false)
    const [modalTitle, setmodalTitle] = useState("")
    const [modalContent, setmodalContent] = useState("")
    const toggleModalVisibility = (vis) => {
        setcardModalState(vis)
    }
    const updateModalContent = (card) => {
        toggleModalVisibility(true)
        setmodalTitle(card.title)
        setmodalContent(card.description)
    }

    return (
        <div id="home">
            <div id="home-bg">
                <div id="intro">
                    <h1>
                        𝙷𝚊𝚜𝚜𝚊𝚗 𝚀𝚞𝚛𝚊𝚗 𝙰𝚌𝚊𝚍𝚎𝚖𝚢
                        <hr />
                        Learn Quran with Us
                    </h1>
                    {/* <p>
                    </p> */}
                </div>
                <ContactForm />
            </div>
            <div className="home-desc">
                <div id="intro-2">
                    <h1>
                        خَيْرُكُمْ مَنْ تَعَلَّمَ الْقُرْآنَ وَعَلَّمَهُ
                            <br />
                    The best among you are those who learn the Qur'an and teach it
                </h1>
                    <p> Every Muslim knows the importance of learning the Quran, but only a few attempts to spend their lives on the basis of the Quran and Islamic teachings. Our Online Quran Center is established with the aim to spread the knowledge of the religion Islam and the Quran, especially among those who are residing in places where there are no reliable resources for learning Quran. Being the best online the Quran institute, our aim also includes the establishment of the religion Islam. We are striving to promote online Quran learning with the latest technology.  We have been teaching Quran and Islam for years and have the aim to spread the light of Islam across the world.</p>
                    <hr />
                    <div className="home-desc">
                        <h1>Hassan Quran Academy</h1>
                        <p>
                            When it comes to online Quran teaching, Hassan Quran Academy offers its services to provides online Quran classes for kids and adults. We adopt the latest methods of teaching to provide a better learning experience to our students. Being the best Quranic academy, we take every step to ensure the satisfaction of our students. For that purpose, we provide discounts on the student’s fee, trial classes, flexible timings and affordable fee structure.
                            Through our best Quran online classes, we create a perfect learning environment to make it easier to learn Quran online for adults and kids.
                        <br />
                        </p>
                    </div>

                </div>
                <CourseCards />
                {/* --------------- */}
                <div style={{ width: "100%" }}>
                    {/* <h1 style={{ color: "black" }}>
                        Services
                    </h1> */}
                    {/* modal */}
                    {/* <button onClick={() => { toggleModalVisibility(true) }}>Click me</button> */}
                    <CardModal modalVisbitlity={cardModalState} toggleModalVisibility={toggleModalVisibility} title={modalTitle} content={modalContent}></CardModal>
                    {/*  */}
                </div>
                <div className="card-container">
                    {
                        servicesCards.map(card => (
                            <div onClick={() => { updateModalContent(card) }}>
                                <Card img={card.img} title={card.title} description={card.description} key={card.title} Width={"50%"} />
                            </div>
                        ))
                    }
                </div>

                <div className="home-desc-child" >
                    <h2>WHY LEARN WITH US?</h2>
                    <p>
                        Have these existing portals and Quranic forums gotten you confused with indifferent interpretations and misleading Quranic information?                     </p>

                    <p>
                        Do you strive to learn the Quran from verified and certified islamic scholars?
                    </p>
                    <p>
                        Hassan Academy has got you covered. We will save you from the confusion and get your Quranic concepts right. Our staff, the Scholars and Teachers in our panel, Teaching Assistants, and the institute’s moderators is all learned and certified people with Quranic and Arabic degrees.
                    </p>
                    <p>
                        We take full responsibility for the content we teach our students to be accurate and authentic. A lot of thoughts, efforts, and energies are put into structuring each course for you. We provide you with relevant course material, which is covered over the course of each session. Not only do we help you learn and gain knowledge, but having a firm hold over that particular subject and making sure it stays with you for long enough is also a priority.
                    </p>

                    <p>
                        The satisfaction of our students is the most important thing for Quran Schooling. We take every possible step to satisfy the students with the teachers they are provided with. To maintain this legacy, we take reviews from our students from time to time. We give great importance to these reviews. We judge the performance of our teachers based on the reviews provided by our students. If we come to know that the student is not satisfied with learning from a particular teacher, we do replace the teacher.
                    </p>
                    <p>
                        Moreover, our focus is to offer you different Quranic and Arabic courses and work hard for you to master all the topics by the end of the session. We put a lot of effort and energy into compiling content for these courses, to provide authentic educational materials to you, to help you practice during lectures and otherwise at home too.

                    </p>
                    <p>
                        Furthermore, we follow your performance in the homework assigned to you and your children at each lesson. Then, we provide tests for you to ensure that you are grasping all concepts and progressing.
                    </p>
                    {/* <h2>
                        Number of Tests to Check
                        </h2>
                    <p>

                        We always recruit the best Quran teachers who help our students to learn Tajweed online. We know that an incompetent teacher can never proficiently teach them to learn Tajwid Quran. To choose the best qari for our students, Quran Schooling has created a series of tests to check the capability of the teacher. Anyone who passes these tests and meets our criteria is selected to help them to learn Tajweed Quran online.
                        </p>

                    <h2>
                        Adaptable Timings For Online Tajweed Lessons
                    </h2>

                    <p>
                        While going to a madrasa, the main problem a student encounters is its timings. It becomes difficult for a student to follow the strict time table and reach on time every day. It causes a great loss of Tajweed learning for students. But it is no longer a problem because Quran Schooling offers you online tajweed classes, with flexible timings. After registration, you can decide timings for your session according to your own convenience. Having this opportunity makes it easier for the students to schedule the classes according to their availability. In this way, they will no longer miss their online tajweed classes.

                            </p>
                    <h2>
                        We value your Review Serious
                    </h2>
                    <p>

                        The satisfaction of our students is the most important thing for Quran Schooling. We take every possible step to satisfy the students with the teachers they are provided with. To maintain this legacy, we take reviews from our students from time to time. We give great importance to these reviews. We judge the performance of our teachers based on the reviews provided by our students. If we come to know that the student is not satisfied with learning Tajweed from a particular teacher, we do replace the teacher.
                    </p>

                    <h2>
                        Individual Learning Sessions
                    </h2>
                    <p>
                        When a student goes to a madrasa, chances are that one cannot get proper attention from the teacher due to a large number of students. We understand that it becomes difficult for a student to learn Quran tajwid if there is a lot of disturbance near one. To solve this problem, Quran Schooling offers one to one sessions in online tajweed classes.                        <br />
                    </p> */}
                </div>

            </div>
        </div >
    );
}

